import { Injectable } from "@angular/core";
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from "@angular/router";
import { TranslateProvider, WordpressService } from '..';
import { LoaderService } from "../loader/loader.service";
import { catchError, delay, finalize, take, takeUntil, tap, timeout } from "rxjs/operators";
import { throwError, timer } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class ItemResolverService implements Resolve<any> {

  constructor(
    private translate: TranslateProvider,
    public posts: WordpressService,
    private ionLoader: LoaderService,
    private router: Router  
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.showLoader();
    let postID = route.params['id']; //route.data['postid']; 
    const timer$ = timer(3000); // Tiempo límite de 3 segundos
    return this.posts.getItem(postID).pipe(
      tap(() => this.hideLoader()),
      catchError((error) => {
        console.error('Error en el resolver', error);
        // Manejar el error aquí, por ejemplo, mostrar una página de error y navegar a ella
        this.router.navigate(['/posts-list']);
        // Lanzar el error para que se pueda manejar en el componente que utiliza el resolver
        return throwError(error);
      }),
      takeUntil(timer$), // Cancela el tiempo de espera si la operación se completa antes de los 3 segundos
      finalize(() => this.hideLoader())
    );
  }


  showLoader() {
    this.ionLoader.showLoader();
  }

  hideLoader() {
    this.ionLoader.hideLoader();
  }
}